export const transferSteps = {
  transferStepsBeneficiary: "Begunstigde",
  transferStepsAmount: "Bedrag",
  transferStepsTransfer: "Oopskakel",
  transferStepsError: "Oordrag het misluk",
  transferStepsErrorDesc_1: "Jou oordrag het misluk, kontroleer asseblief jou data of kontak ondersteuning.",
  transferStepsSuccess: "Oordrag suksesvol",
  transferStepsSuccessMessage: "Jou oordrag is suksesvol verwerk.",
  transferStepsNext: "Volgende",
  transferStepsConfirm: "Bevestig",
  transferStepsBack: "Terug",
  transferStepsCancel: "Kanselleer",

  // Inhoud stap 1,
  transferStepsSelectContact: "Kies kontak",
  transferStepsSelectContactOption: "Kies 'n kontak",
  transferSteps_loading: "Laai kontakte...",
  transferSteps_loadingError: "Fout met die laai van kontakte",

  // Inhoud stap 2,
  transferStepsTransferAmount: "Voer die bedrag in om oor te dra",
  transferStepsTransferAmountInput: "Voer bedrag in",
  transferStepsAmountError: "Ongeldige bedrag",
  transferStepsAmountError2: "Onvoldoende saldo",

  // Inhoud stap 3,
  transferSteps_3_Confirm: "Oordragbevestiging",
  transferSteps_3_Beneficiary: "Begunstigde ",
  transferSteps_3_Amount: "Bedrag",
};
